import { render } from "./CustomersHeader.vue?vue&type=template&id=c4e25938&scoped=true"
import script from "./CustomersHeader.vue?vue&type=script&lang=js"
export * from "./CustomersHeader.vue?vue&type=script&lang=js"

import "./CustomersHeader.vue?vue&type=style&index=0&id=c4e25938&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e25938"]])

export default __exports__